import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as ReasonHttp from '../../../../services/api/https/picking/missing-reason.http'
import * as ReasonStandardHttp from '../../../../services/api/https/system/missing-reason-standard.http'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_REASONS: 'Adquirindo ocorrências',
  GET_REASONS_STANDARD: 'Adquirindo ocorrências padrão',
}

const INITIAL_STATE = {
  ocorrencias: [],
  ocorrenciasPadrao: [],
  selectedEmpresaID: '',
  modal: {
    show: false,
    data: null,
  },
  loadingMessage: LOAD_MESSAGE.GET_REASONS_STANDARD,
  errorMessage: null,
  activeTab: 0,
  ocorrenciaFilter: '',
  ocorrenciaPadraoFilter: '',
}

const INITIAL_OCCURRENCE = {
  id: null,
  company_id: '',
  sigla: '',
  descricao: '',
  type: 'Falta',
  visible_picking: false,
  visible_delivery: false,
  devolucao_fisica: true,
  actived: true,
  company_code: null,
}

export default function useOcorrenciaEmpresa() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      getMissingReasons(empresaID) {
        ReasonHttp.getMissingReasons(empresaID)
          .then(ocorrencias =>
            setState(prevState => ({
              ...prevState,
              ocorrencias: ocorrencias,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      getMissingReasonStandard() {
        ReasonStandardHttp.getMissingReasonStandard()
          .then(ocorrencias =>
            setState(prevState => ({
              ...prevState,
              ocorrenciasPadrao: ocorrencias,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      // Events
      onEmpresaChange(selectedEmpresa) {
        setState(prevState => ({
          ...prevState,
          selectedEmpresaID: selectedEmpresa.id,
          loadingMessage: LOAD_MESSAGE.GET_REASONS,
        }))
      },

      onBtnNovo(selectedEmpresaID) {
        if (selectedEmpresaID !== '')
          setState(prevState => ({
            ...prevState,
            modal: { show: true, data: { ...INITIAL_OCCURRENCE, company_id: selectedEmpresaID } },
          }))
        else setState(prevState => ({ ...prevState, errorMessage: 'Selecione a empresa desejada' }))
      },

      onModalClose() {
        setState(prevState => ({
          ...prevState,
          modal: { show: false, data: { ...INITIAL_OCCURRENCE } },
        }))
      },

      onModalSave(ocorrencia) {
        setState(prevState => {
          const index = prevState.ocorrencias.findIndex(o => o.id === ocorrencia.id)
          if (index !== -1) prevState.ocorrencias[index] = ocorrencia
          else prevState.ocorrencias.push(ocorrencia)
          return { ...prevState, modal: { show: false, data: null } }
        })
      },

      onRowClicked(ocorrencia) {
        setState(prevState => ({ ...prevState, modal: { show: true, data: ocorrencia } }))
      },

      onTabChange(value) {
        setState(prevState => ({
          ...prevState,
          activeTab: value,
          ocorrenciaFilter: '',
          ocorrenciaPadraoFilter: '',
        }))
      },

      onChangeOcorrenciaFitler(value) {
        setState(prevState => ({ ...prevState, ocorrenciaFilter: value }))
      },

      onChangeOcorrenciaPadraoFitler(value) {
        setState(prevState => ({ ...prevState, ocorrenciaPadraoFilter: value }))
      },

      onAddRemoveOcorrencia(ocorrencia, companyId, checked) {
        if (!checked) {
          const ocorrenciaToSave = {
            ...ocorrencia,
            company_id: companyId,
            company_code: null,
          }
          ReasonHttp.saveMissingReason(ocorrenciaToSave)
            .then(ocorrencia =>
              setState(prevState => ({
                ...prevState,
                ocorrencia: ocorrencia,
                loadingMessage: LOAD_MESSAGE.GET_REASONS,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                errorMessage: errorHandler(err),
              })),
            )
          return
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
